import React from 'react';
import { handleDownloadPdf, selectLoader } from '../../../utils/Helpers';
import fileIcon from '../../../assets/img/document2.svg';
import deleteBtn from '../../../assets/img/delete.svg';
import downloadimg from '../../../assets/img/download-icon3.svg';

const UpdatedScope = ({ scopeData, loading }) => {
  return (
    <div className="accordion" id="faq">
      {loading ? (
        <div className="nodata-loader">{selectLoader(65)}</div>
      ) : (
        <>
          {scopeData?.contract && (
            <div className="card_cover card_cover_scopeWork">
              <div className="file_item">
                <a href={scopeData?.contract.url} target="_blank" className="attachment-tag">
                  <div className="img-details">
                    <h6>Contract</h6>
                    <div className="file_name">
                      <img src={fileIcon} />
                      <span className="file_size">{scopeData?.contract.name}</span>
                    </div>
                  </div>
                  <img
                    src={downloadimg}
                    alt="downloadimg"
                    className="uploadImg cursor_pointer"
                    onClick={(e) => {
                      e.preventDefault();
                      handleDownloadPdf(scopeData?.contract.url, scopeData?.contract.name);
                    }}
                  />
                </a>
              </div>
            </div>
          )}
          {scopeData?.attachments?.length > 0 &&
            scopeData.attachments.map((file, index) => (
              <div className="card_cover card_cover_scopeWork">
                <div className="file_item" key={index}>
                  <a href={file.url} target="_blank" className="attachment-tag">
                    <div className="img-details">
                      <h6>{file.name}</h6>
                      <div className="file_name">
                        <img src={fileIcon} />
                        <span className="file_size">{file.size}</span>
                      </div>
                    </div>
                    <img
                      src={downloadimg}
                      alt="downloadimg"
                      className="uploadImg cursor_pointer"
                      onClick={(e) => {
                        e.preventDefault();
                        handleDownloadPdf(file.url, file.name);
                      }}
                    />
                  </a>
                </div>
              </div>
            ))}

          {scopeData?.scopeText?.length > 0 && (
            <div className="card_cover">
              <div className="card-header">
                {/* {item.title} */}
                Scope of Work
              </div>

              <div className="card-body">
                <p
                  dangerouslySetInnerHTML={{
                    __html: scopeData?.scopeText
                  }}></p>
                {/* <span>{scopeData?.scopeText}</span> */}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default UpdatedScope;
